import _slicedToArray from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { apiQueryExchangeRate } from '../api/universal';
import { formatCurrency } from '../shared/formatters';
import { multiplyNumber } from '../utils/decimal';
export var useCurrencyStore = create()(immer(function (set, get) {
  return {
    state: {
      benchmarkCurrency: 'EUR',
      exchangeRate: null
    },
    actions: {
      queryExchangeRateInfo: function () {
        var _queryExchangeRateInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var _yield$apiQueryExchan, _yield$apiQueryExchan2, res;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return apiQueryExchangeRate();

                case 2:
                  _yield$apiQueryExchan = _context.sent;
                  _yield$apiQueryExchan2 = _slicedToArray(_yield$apiQueryExchan, 1);
                  res = _yield$apiQueryExchan2[0];

                  if (res) {
                    set(function (store) {
                      store.state.exchangeRate = res;
                    });
                  }

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function queryExchangeRateInfo() {
          return _queryExchangeRateInfo.apply(this, arguments);
        }

        return queryExchangeRateInfo;
      }(),
      calculateCurrencyRate: function calculateCurrencyRate(currentCurrency, covertCurrency, config) {
        var exchangeRate = get().state.exchangeRate;

        if (!exchangeRate || !(exchangeRate !== null && exchangeRate !== void 0 && exchangeRate[currentCurrency]) || !(exchangeRate !== null && exchangeRate !== void 0 && exchangeRate[covertCurrency])) {
          return {
            amount: formatCurrency({
              amount: (config === null || config === void 0 ? void 0 : config.amount) || 0,
              currency: currentCurrency
            }),
            rate: 1
          };
        }

        var rate = multiplyNumber(1 / exchangeRate[currentCurrency], exchangeRate[covertCurrency]);
        rate = Number(rate.toFixed(4));
        return {
          rate: rate,
          amount: formatCurrency({
            amount: multiplyNumber(config === null || config === void 0 ? void 0 : config.amount, rate),
            currency: covertCurrency
          }),
          perOccurrence: formatCurrency({
            amount: multiplyNumber(config === null || config === void 0 ? void 0 : config.perOccurrence, rate),
            currency: covertCurrency
          }),
          diseaseEachEmployee: formatCurrency({
            amount: multiplyNumber(config === null || config === void 0 ? void 0 : config.diseaseEachEmployee, rate),
            currency: covertCurrency
          }),
          diseasePolicyLimit: formatCurrency({
            amount: multiplyNumber(config === null || config === void 0 ? void 0 : config.diseasePolicyLimit, rate),
            currency: covertCurrency
          })
        };
      }
    }
  };
}));